import { useAmelioTranslations } from '@/hooks';

export type ProgressBarProps = {
    progressPercentage: number;
    gradientClassName: string;
    dataTestId?: string;
};

export const ProgressBar = ({
    progressPercentage,
    gradientClassName,
    dataTestId,
}: ProgressBarProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            className={
                'absolute inset-x-0 bottom-6 mx-auto w-[calc(100%-3rem)] sm:w-[calc(100%-6rem)]'
            }
            data-testid={dataTestId}
        >
            <div className={'relative h-8 w-full overflow-hidden rounded-full bg-white/20'}>
                <div
                    className={`h-full rounded-full ${gradientClassName} transition-all duration-500 ease-out`}
                    style={{ width: `${progressPercentage}%` }}
                />

                <span
                    className={
                        'absolute inset-0 flex items-center justify-center text-sm font-semibold whitespace-nowrap text-white'
                    }
                >
                    {`${t('answer.progression')}: ${progressPercentage}%`}
                </span>
            </div>
        </div>
    );
};
